// extracted by mini-css-extract-plugin
module.exports = {"container":"_9400a595a7--container--ChNpi","header":"_9400a595a7--header--ClOD3","text":"_9400a595a7--text--Um8yz"};